import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="A vibrant protest scene at the Capitol, showcasing civic activism and community engagement." 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Capitol Protest</p>
        <h1>Empower Your Voice: Join the Movement for Change</h1>
        <p className="lede">
          Discover essential resources and information to engage in impactful civic activism at the Capitol.
        </p>
        <div className="cta-row">
          <a href="/resources" className="primary">
            Explore Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Protest Planning Guides</h2>
          <p>
            Access comprehensive guides to help you plan and participate in protests effectively and safely.
          </p>
        </article>
        <article>
          <h2>Know Your Rights</h2>
          <p>
            Understand your legal rights as a protester to ensure your voice is heard without fear.
          </p>
        </article>
        <article>
          <h2>Safety and Health Tips</h2>
          <p>
            Stay informed about best practices for maintaining your safety and health during demonstrations.
          </p>
        </article>
        <article>
          <h2>Community Stories</h2>
          <p>
            Read inspiring stories from fellow activists and learn from their experiences in civic engagement.
          </p>
        </article>
        <article>
          <h2>Upcoming Events</h2>
          <p>
            Stay updated on upcoming protests and civic events to ensure you never miss an opportunity to participate.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;